<template>
  <div class="bg">
    <div class="login_box">
      <div class="login">
        <div class="login_left">
          <span>智谷CTIS区块链考试平台</span>
          <!-- <Img class="logo" src="/logo.png" alt="" /> -->
          <!-- <dl>
            <dt>
              联系我们
            </dt>
            <dd>
              <Img src="/home/qrcode.jpg" />
            </dd>
          </dl> -->
        </div>
        <Card class="login-card">
          <p slot="title" v-if="type === 1">
            <!-- {{ loginFormData.kind === 1 ? '学生登录' : '教师登录' }} -->
            登录
          </p>
          <p slot="title" v-if="type != 1">
            {{ type === 1 ? '登录' : type === 2 ? '注册' : '找回密码' }}
          </p>
          <br />
          <br />
          <br />
          <br />
          <Form ref="loginFormData" class="card_form" :model="loginFormData" :rules="loginRules" :label-width="106" v-show="type === 1" label-position="left">
            <FormItem prop="phone">
              <span slot="label"><Img src="/phone.png" class="ipt-icon" />账号</span>
              <Input type="text" v-model.trim="loginFormData.phone" placeholder="请输入账号" @keyup.enter.native="handleSubmit('loginFormData')" />
            </FormItem>
            <FormItem prop="password">
              <span slot="label"><Img src="/password.png" class="ipt-icon" />密码</span>
              <Input type="password" v-model.trim="loginFormData.password" placeholder="请输入密码" @keyup.enter.native="handleSubmit('loginFormData')" />
              <!-- <span class="forgetpwd primary" @click="loginFormData.kind === 1 ? (loginFormData.kind = 2) : (loginFormData.kind = 1)">{{
                loginFormData.kind === 1 ? '教师登录' : '学生登录'
              }}</span> -->
            </FormItem>
          </Form>
          <Form ref="regFormData" class="card_form" :model="regFormData" :rules="regRules" :label-width="106" v-if="type !== 1" label-position="left">
            <FormItem prop="phone">
              <span slot="label"><Img src="/phone.png" class="ipt-icon" />手机号</span>
              <Input type="text" v-model.trim="regFormData.phone" placeholder="请输入手机号" />
            </FormItem>
            <FormItem prop="authCode">
              <span slot="label"><Img src="/verification-code.png" class="ipt-icon" />验证码</span>
              <Input v-model.trim="regFormData.authCode" placeholder="请输入验证码">
                <Button class="get_btn" type="primary" :disabled="codeStatus" @click="getCode" slot="append">{{
                  codeStatus ? `${this.timeCount}s` : '获取'
                }}</Button>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <span slot="label"><Img src="/password.png" class="ipt-icon" />密码</span>
              <Input type="password" v-model.trim="regFormData.password" placeholder="请输入密码" />
            </FormItem>
          </Form>
          <div class="btngroup" v-if="type === 1">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('loginFormData')">登录</Button>
            <div class="register">
              <!-- <Button @click="type = 2">免费注册</Button>
              <p @click="type = 3">忘记密码</p> -->
            </div>
          </div>
          <div class="btngroup" v-if="type === 2">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('regFormData')">注册</Button>
            <div class="register">
              <p class="color_333 margin_auto">已有账号，去<span @click="type = 1">登录</span></p>
            </div>
          </div>
          <div class="btngroup" v-if="type === 3">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('regFormData')">设置密码</Button>
            <div class="register">
              <p class="color_333 margin_auto">已有账号，去<span @click="type = 1">登录</span></p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Form, FormItem, Input, Card } from 'view-design'
import sha256 from 'js-sha256'
import { PhoneValid, PUValid } from '@/utils/check'
export default {
  components: {
    Button,
    Form,
    FormItem,
    Input,
    Card
  },
  data() {
    return {
      bg_img: '',
      bannerList: [],
      type: 1, // 1-登录 2-注册 3-找回密码
      // 登录form
      loginFormData: {
        phone: '',
        password: ''
      },
      // 注册/重置密码form
      regFormData: {
        phone: '',
        password: '',
        kind: 1,
        authCode: ''
      },
      // 登录验证
      loginRules: {
        phone: [
          { required: true, message: '请输入账号', trigger: 'blur' }
          // { validator: PhoneValid, message: '手机号格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
          // { validator: PUValid, message: '密码格式错误', trigger: 'blur' }
        ]
      },
      // 注册验证
      regRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: PhoneValid, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, trigger: 'blur' }
        ],
        kind: [{ required: true, type: 'number', message: '请选择身份', trigger: 'change' }],
        authCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      handleBtnLoading: false, // 登录/注册按钮状态
      codeStatus: false, // false-可获取，true-获取中
      timeCount: 0 // 倒计时
    }
  },
  methods: {
    // 获取验证码
    getCode() {
      this.$refs['regFormData'].validateField('phone', async valid => {
        if (!valid) {
          const params = {
            uriCode: 'API003',
            phone: this.regFormData.phone,
            kind: this.type === 2 ? 1 : 2
          }
          await this.$fetch(params)
          this.$msg.success('获取成功')
          this.codeStatus = true
          this.timeCount = 60
          this.countdown()
        } else {
          return
        }
      })
    },
    // 倒计时
    countdown() {
      let timer = null
      timer = setInterval(() => {
        if (this.codeStatus && this.timeCount > 1) {
          this.timeCount--
        } else {
          this.timeCount = 0
          this.codeStatus = false
          clearInterval(timer)
          timer = null
        }
      }, 1000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(timer)
        timer = null
      })
    },
    /**
     * 验证
     * name:表单名称
     */
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.type === 1) {
            this.login()
          } else if (this.type === 2) {
            this.signup()
          } else {
            this.signup()
          }
        }
      })
    },
    // 注册/重置密码
    async signup() {
      this.handleBtnLoading = true
      const params = {
        uriCode: this.type === 2 ? 'API001' : 'API005',
        ...this.regFormData,
        password: sha256(this.regFormData.password)
      }
      try {
        await this.$fetch(params)
        this.$msg.success(`${this.type === 2 ? '注册' : '重置密码'}成功,请登录`)
        this.type = 1
      } finally {
        this.handleBtnLoading = false
      }
    },
    // 登录
    async login() {
      this.handleBtnLoading = true
      const params = {
        uriCode: 'API001',
        ...this.loginFormData,
        password: sha256(this.loginFormData.password)
      }
      try {
        const res = await this.$fetch(params)
        // 清除本地缓存
        this.$store.dispatch('clearLocal')
        // 设定为真实考试
        localStorage.setItem('realExam', this.$route.query.realExam || '1')
        localStorage.setItem('X-Token', res.token)
        this.$msg.success('登录成功')
        this.$router.push({ name: 'home' })
      } finally {
        this.handleBtnLoading = false
      }
    }
  },
  watch: {
    type() {
      this.$refs['loginFormData'].resetFields()
      this.$refs['regFormData'].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.forgetpwd {
  float: right;
  margin-top: 4px;
  cursor: pointer;
}
.todo {
  cursor: pointer;
}
.ipt-icon {
  width: 11px;
  height: 11px;
  margin-right: 5px;
  position: relative;
  bottom: 1px;
}
.bg {
  min-width: 900px;
  min-height: calc(100vh);
  background: url('~@/../public/images/login_bg.webp') center no-repeat;
  background-size: cover;
}
.login_box {
  width: 900px;
  min-height: 700px;
  height: calc(100vh);
  position: relative;
  margin: 0 auto;
  .login {
    width: 900px;
    height: 478px;
    display: flex;
    position: absolute;
    top: 25%;
    .login_left {
      width: 420px;
      height: 478px;
      background: url('~@/../public/images/login_img.png') center no-repeat;
      box-sizing: border-box;
      color: #fff;
      text-align: center;
      line-height: 478px;
      font-size: 23px;
      .logo {
        width: 60%;
        margin: 0 auto 80px;
        display: block;
      }
      dl {
        text-align: center;
        dt {
          margin-bottom: 15px;
        }
        img {
          width: 100px;
        }
      }
    }
    &-card {
      border-radius: 0%;
      width: 480px;
      height: 478px;
      margin: 0px auto;
      .card_form {
        box-sizing: border-box;
        padding: 0 60px;
      }
    }
  }
}
.btngroup {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  .login_btn {
    width: 260px !important;
    height: 40px !important;
    box-shadow: 0px 4px 30px 0px rgba(0, 213, 134, 0.3);
    margin: auto;
  }
  .register {
    width: 330px;
    height: 40px;
    margin-top: 20px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    button {
      width: 89px;
      height: 32px;
      border-radius: 2px;
      color: #0059ff;
      border: 1px solid #015fff;
      margin-top: 4px;
      font-size: 14px;
    }
    button:hover {
      background-color: #015fff;
      color: #fff !important;
    }
    span {
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #015fff;
      text-align: center;
    }
    p {
      cursor: pointer;
    }
    p:hover {
      opacity: 0.8;
    }
  }
}
.color_333 {
  color: #333 !important;
}
.margin_auto {
  margin: auto !important;
}
.get_btn {
  width: 60px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  height: 32px !important;
  line-height: 32px !important;
}
</style>
